import {User} from 'projects/core/src/lib/login/data/user';
import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProjectActivity} from '../../project-misc/data/project/activity/project-activity';
import {ProjectStatus} from '../../project-misc/data/project/statuses/project-status';

@JsonObject('model.activity.RouteVehicle')
export class RouteVehicle extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Number, 'totalDuration')
  totalDuration?: number;

  @JsonProperty(Boolean, 'routeOptimized')
  routeOptimized?: boolean;

  @JsonProperty([ProjectActivity], 'activities')
  activities?: ProjectActivity[];

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(String, 'lastInteractionTime')
  lastInteractionTime?: string;

  @JsonProperty(String, 'routeUrl')
  routeUrl?: string;

  @JsonProperty(ProjectStatus, 'status')
  status?: ProjectStatus;

  @JsonProperty(ProjectStatus, 'defaultActivityType')
  defaultActivityType?: ProjectStatus;

  @JsonProperty(User, 'user')
  user?: User;
}
